import { TabPanelInner } from 'components/Tabs';
import { useAppSelector } from 'store/hooks';
import RoomE2EECode from 'components/RoomE2EECode';
import { selectRoomE2eeCode } from 'features/e2ee/e2eeSlice';
import { Typography, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CopyButton from 'components/CopyButton/CopyButton';
import { useEffect } from 'react';
import { useCopyButton } from 'components/CopyButton/useCopyButton';

const SecurityTab = () => {
  const { t } = useTranslation('settings');

  const { copied, copyToClipboard, resetCopied } = useCopyButton();

  const roomCode = useAppSelector(selectRoomE2eeCode);

  useEffect(() => {
    resetCopied();
  }, [roomCode, resetCopied]);

  return (
    <TabPanelInner>
      <Stack spacing={5}>
        <Typography>{t('security.room_e2ee_code.title')}</Typography>
        <Typography>{t('security.room_e2ee_code.description')}</Typography>
        <RoomE2EECode roomCode={roomCode} />
        <div>
          <CopyButton
            copied={copied}
            onCopy={copyToClipboard}
            text={roomCode.join(' ')}
            sx={{
              color: 'inherit',
              textTransform: 'uppercase',
            }}
          >
            {(isCopied) =>
              isCopied
                ? t('settings:security.room_e2ee_code.btn_copied_label')
                : t('settings:security.room_e2ee_code.btn_copy_label')
            }
          </CopyButton>
        </div>
      </Stack>
    </TabPanelInner>
  );
};

export default SecurityTab;
